import React, { useEffect, useState } from "react";
import { ProjectContainer } from "../styles/projectTab";
import CamperImg from "../assets/camper.webp";
import CrmImg from "../assets/crm.webp";
import { ProjectCard } from "./project-card";
import CamperAdmin from "../assets/camper-admin.webp";
import XalqlarAdmin from "../assets/xalqlar-admin.png";

const Game = () => {
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpacity(1);
    }, 200);

    return () => clearTimeout(timer);
  }, []);
  return (
    <ProjectContainer style={{ opacity, transition: "opacity 0.5s" }}>
      <ProjectCard
        link="https://xalqlar-dostligi.uz/auth/login"
        image={XalqlarAdmin}
        title="Xalqlar (admin-dashboard)"
        subtitle="Web application"
      />
      <ProjectCard
        link="https://camper.inomjonov.site"
        image={CamperImg}
        title="Camper"
        subtitle="Web application"
      />
      <ProjectCard
        link="https://lms.inomjonov.site"
        image={CrmImg}
        title="EduManSim (Learning Management System)"
        subtitle="Web applicationss"
      />
      <ProjectCard
        link="https://admin-dashboard.camper.inomjonov.site"
        image={CamperAdmin}
        title="Camper (admin-dashboard)"
        subtitle="Web applicationss"
      />
    </ProjectContainer>
  );
};

export default Game;
